/* eslint-disable prettier/prettier */
import axios from 'axios'

const state = {
    users: [],
    user: {},
    showDeleteModal: false,
    isLoadingList: false
}

const mutations = {
    getUsers(state) {
        state.isLoadingList = true
        axios.get(`api/users`).then(response => {
            state.users = response.data;
        }).catch(error => {
            // eslint-disable-next-line no-console
            console.log(error)
        }).then(() => {
            state.isLoadingList = false
        })
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.user) {
            state.user = payload.user
        } else {
            state.user = {}
        }
    }
}

const actions = {
    getUsers({
        commit
    }) {
        commit("getUsers")
    },
    openDeleteModal({
        commit
    }, payload) {
        commit("openDeleteModal", payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}